/**
 * 學校進階搜尋頁（僅前端表單；不使用 Bootstrap-Vue，避免與站內 BS3 樣式衝突）
 */
require('../bootstrap');
require('../../sass/school-search-list-table.scss');
window.Vue = require('vue');

import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

import SchoolSearchPage from './SchoolSearchPage.vue';

new Vue({
  el: '#school-search-app',
  render: (h) => h(SchoolSearchPage),
});



// WEBPACK FOOTER //
// ./resources/js/school-search/school-search.js